import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import EarlyAccessPage from "./components/EarlyAccessPage";
import { COLORS } from "./utils/colors";

// This is a template App component that can be customized for any app
function App() {
  // App configuration - customize these values for your app
  const appConfig = {
    // App info
    appName: "Somewords",
    appTagline: "Emotional capture for life's biggest moments",
    appDescription: "Somewords turns fleeting gatherings into living, breathing memory capsules. Capture not just faces, but feelings, laughter, and heartfelt wisdom.",
    logoPath: "logo192.png", // Using existing logo
    
    // Hero section
    heroTitle: "Capture",
    heroHighlight: "Life's Emotions",
    heroDescription: "At weddings, baby showers, anniversaries, and celebrations, Somewords captures who people are — their emotions, their voices, their dreams — at moments that will never come again.",
    heroCta: "Get the App",
    heroSecondaryAction: "How It Works",
    
    // App screenshots
    screenshots: ["screen1NewNew.png", "screen2NewNew.png"],
    
    // Features section
    featuresTitle: "More Than",
    featuresHighlight: "Just Photos",
    featuresDescription: "Somewords doesn't just show who was there — it captures who they were at a moment that will never come again.",
    phases: [
      {
        title: "For Hosts",
        subtitle: "Create lasting memories",
        items: [
          "Download the Somewords app",
          "Set up your event in minutes",
          "Place QR codes around your venue",
          "Receive heartfelt messages from guests"
        ],
      },
      {
        title: "For Guests",
        subtitle: "No app download needed",
        items: [
          "Simply scan a QR code",
          "Record a video or snap a selfie",
          "Answer heartfelt prompts",
          "Leave your mark in under 30 seconds"
        ],
      },
      {
        title: "After the Event",
        subtitle: "Relive the emotions",
        items: [
          "View all submissions in the app",
          "Download your memory collection",
          "Order a printed hardcover keepsake",
          "Share highlights on social media"
        ],
      },
    ],
    
    // Testimonials
    testimonialsTitle: "Emotional Memories That Last Forever",
    testimonials: [
      {
        quote: "I cried when I opened our Somewords collection. Hearing my grandmother's advice for our marriage is something I'll treasure forever.",
        author: "— Sarah, Bride",
      },
      {
        quote: "As a wedding photographer, I've seen it all. Somewords captures something my camera never could - the actual voices and emotions of the day.",
        author: "— Michael, Wedding Photographer",
      },
      {
        quote: "At my retirement party, my colleagues left Somewords messages that made me laugh and cry. It's so much more meaningful than a card.",
        author: "— Janet, 65",
      },
    ],
    
    // Social proof
    socialProofTitle: "Somewords Moments",
    socialProofEmbeds: [
      // Will add TikTok embeds when available
    ],
    
    // Download section
    downloadTitle: "Host with the app. Guest with just a tap.",
    downloadDescription: "Your photos show what life looked like. Somewords shows how deeply you were loved.",
    
    // Store links
    appStoreLink: "/early-access",
    playStoreLink: "/early-access",
    
    // Footer
    footerText: `© ${new Date().getFullYear()} Somewords. All rights reserved.`,
    
    // Early access page
    earlyAccessFeatures: [
      "Capture emotional video messages from all your guests",
      "No app download needed for guests - just scan a QR code",
      "Create a digital memory capsule of your special day",
      "Optional hardcover keepsake with all your memories"
    ],
    apiEndpoint: "https://api.somewords.app/api/presignup",
    accentColor: COLORS.primary,
    initialSignupCount: 3290,
    targetSignupCount: 3317,
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage 
          appName={appConfig.appName}
          appTagline={appConfig.appTagline}
          appDescription={appConfig.appDescription}
          logoPath={appConfig.logoPath}
          heroTitle={appConfig.heroTitle}
          heroHighlight={appConfig.heroHighlight}
          heroDescription={appConfig.heroDescription}
          heroCta={appConfig.heroCta}
          heroSecondaryAction={appConfig.heroSecondaryAction}
          screenshots={appConfig.screenshots}
          featuresTitle={appConfig.featuresTitle}
          featuresHighlight={appConfig.featuresHighlight}
          featuresDescription={appConfig.featuresDescription}
          phases={appConfig.phases}
          testimonialsTitle={appConfig.testimonialsTitle}
          testimonials={appConfig.testimonials}
          socialProofTitle={appConfig.socialProofTitle}
          socialProofEmbeds={appConfig.socialProofEmbeds}
          downloadTitle={appConfig.downloadTitle}
          downloadDescription={appConfig.downloadDescription}
          appStoreLink={appConfig.appStoreLink}
          playStoreLink={appConfig.playStoreLink}
          footerText={appConfig.footerText}
        />} />
        <Route path="/early-access" element={<EarlyAccessPage 
          appName={appConfig.appName}
          appTagline={appConfig.appTagline}
          appDescription={appConfig.appDescription}
          features={appConfig.earlyAccessFeatures}
          apiEndpoint={appConfig.apiEndpoint}
          accentColor={appConfig.accentColor}
          initialSignupCount={appConfig.initialSignupCount}
          targetSignupCount={appConfig.targetSignupCount}
        />} />
      </Routes>
    </Router>
  );
}

export default App;
